import { stripNonNumericCharacters } from '@thesavingsgroup/utils/stripNonNumericCharacters';

export const toSSNString = (value?: string | number | null): string => {
  const digits = stripNonNumericCharacters(value).slice(0, 9);

  if (digits.length === 0) {
    return '';
  }

  if (digits.length <= 3) {
    return digits;
  }

  if (digits.length <= 5) {
    return `${digits.slice(0, 3)}-${digits.slice(3)}`;
  }

  return `${digits.slice(0, 3)}-${digits.slice(3, 5)}-${digits.slice(5)}`;
};
